var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_918)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 14H18C17.2044 14 16.4413 14.3161 15.8787 14.8787C15.3161 15.4413 15 16.2044 15 17V18.17C14.9999 18.5829 15.085 18.9915 15.25 19.37V19.43C15.3913 19.751 15.5914 20.0427 15.84 20.29L22 26.41V33C21.9997 33.1699 22.0426 33.3372 22.1249 33.4859C22.2071 33.6346 22.3259 33.7599 22.47 33.85C22.6291 33.9486 22.8128 34.0006 23 34C23.1565 33.9991 23.3107 33.9614 23.45 33.89L27.45 31.89C27.6149 31.8069 27.7536 31.6798 27.8507 31.5227C27.9478 31.3656 27.9994 31.1847 28 31V26.41L34.12 20.29C34.3686 20.0427 34.5687 19.751 34.71 19.43V19.37C34.8888 18.9944 34.9876 18.5858 35 18.17V17C35 16.2044 34.6839 15.4413 34.1213 14.8787C33.5587 14.3161 32.7956 14 32 14ZM26.29 25.29C26.1973 25.3834 26.124 25.4943 26.0742 25.6161C26.0245 25.7379 25.9992 25.8684 26 26V30.38L24 31.38V26C24.0008 25.8684 23.9755 25.7379 23.9258 25.6161C23.876 25.4943 23.8027 25.3834 23.71 25.29L18.41 20H31.59L26.29 25.29ZM33 18H17V17C17 16.7348 17.1054 16.4804 17.2929 16.2929C17.4804 16.1054 17.7348 16 18 16H32C32.2652 16 32.5196 16.1054 32.7071 16.2929C32.8946 16.4804 33 16.7348 33 17V18Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_918",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.317647 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_918",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d764414128b5c1f8ce9e4a070f25ea9b.svg";
export { ForwardRef as ReactComponent };